/**
 * Loads new content when a placeholder is at a certain position in the viewport.
 */

define('libs/lazyloader',[],function() {

    'use strict';

    var SETTINGS = {
        //TODO CHANGE THESE
        linkSelector: '.btn-load-more',
        contentSelector: '.search-result-content ul',
        classLoading: 'is-loading',
        offset: 200 // 200px below the viewport
    };

    var LazyLoader = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.root = root;

        var load_link = $(SETTINGS.linkSelector, root);
        this.content = $(SETTINGS.contentSelector, root);
        this.initLoadLink(load_link);

        if (load_link.length) {
            this.scrollListener = this.onScroll.bind(this);
            $(window).on('scroll', this.scrollListener);
            this.onScroll();
        }
    };

    LazyLoader.prototype.onScroll = function() {
        // get link position
        if (this.load_link.length) {
            var y = this.load_link[0].getBoundingClientRect().top;
            if (y - this.settings.offset < window.innerHeight) {
                //load content
                $(window).off('scroll', this.scrollListener);
                this.getContent();
            }
        }
    };

    /**
     * Get the new content.
     * @memberof LazyLoader
     */
    LazyLoader.prototype.getContent = function() {
        var url = this.load_link[0].href;
        if (url) {
            this.load_link.addClass(SETTINGS.classLoading);

            $.ajax(url, {
                success: function(response) {
                    this.addContent(response);
                }.bind(this)
            });
        }
    };

    /**
     * Add behaviour to the lazy loader link.
     * @param {Element} element The lazy load link.
     * @memberof LazyLoader
     */
    LazyLoader.prototype.initLoadLink = function(element) {
        if (this.load_link) {
            this.load_link.remove();
        }
        this.load_link = element;

        // stop any clicks on the link.
        element.on('click', function(event) {
           event.preventDefault();
        });
    };

    /**
     * Remove event from the link and remove it from the DOM.
     * @memberof LazyLoader
     */
    LazyLoader.prototype.destroyLoadLink = function() {
        this.load_link.off('top.enter.viewport');
        this.load_link.remove();
        this.load_link = null;
    };

    /**
     * Process the loaded content.
     * Insert it into the page.
     * Look for the next lazy load link and insert it into the page.
     * @param {String} html The response text from the ajax request.
     * @memberof LazyLoader
     */
    LazyLoader.prototype.addContent = function(html) {
        var content = $(html);
        this.root.append(content);
        var load_link = content.find(SETTINGS.linkSelector, this.root);
        if (load_link.length) {
            this.initLoadLink(load_link);
            $(window).on('scroll', this.scrollListener);
        }
    };

    return LazyLoader;
});

